import { render } from "./PartsAboutSemiOrder.vue?vue&type=template&id=28111d16"
import script from "./PartsAboutSemiOrder.vue?vue&type=script&lang=js"
export * from "./PartsAboutSemiOrder.vue?vue&type=script&lang=js"

import exportComponent from "/Users/maru/Desktop/東野材木/hojokin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__